<template>
  <div class="stage-item">
    <h4 class="stage-item-title">
      <span class="week">{{week}}</span>
      <span class="tip">（圆圈中的数字代表推荐学习天数）</span>
    </h4>
    <div class="stage-item-list">
      <template v-for="(item, index) in items">
        <div :key="index" class="item">
          <span class="days">{{item.days}}</span>
          <span class="word">{{item.content}}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StageItem',
    props: {
      week: String,
      items: Array,
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.stage-item {
  padding: 0 15px;

  &-title {
    margin: 15px 0;

    .week {
      font-size: 16px;
      color: #666;
    }

    .tip {
      font-size: 12px;
      color: #2d92fe;
    }
  }

  &-list {
    .item {
      padding: 10px;
      @include flex-between();
      background-color: #fff;
      border-radius: 5px;
    }

    .item + .item {
      margin-top: 10px;
    }

    .days {
      width: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #fff;
      text-align: center;
      background-color: #5eabfd;
      border-radius: 50%;
    }

    .word {
      flex: 1;
      margin-left: 10px;
      font-size: 14px;
      line-height: 1.5;
      color: #666;
    }
  }
}
</style>
